import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesWarehouses } from "../../constants";
import { IWarehouse, UpdateWarehouseBody } from "../../warehouses.types";

export const requestUpdateWarehouse = async ({
  id,
  body,
}: UpdateWarehouseBody): Promise<IWarehouse> => {
  return await instance.put(buildUrl(ApiRoutesWarehouses.Warehouses, id), body);
};
